export function NotFoundPage() {
  return (
    <div className="center-screen">
      <div className="card stack" style={{ maxWidth: 380, textAlign: "center" }}>
        <h1>Page introuvable</h1>
        <p>Vérifiez le lien que vous avez reçu.</p>
      </div>
    </div>
  );
}
